'use client';
import React, { Fragment } from 'react';

import { ChevronRight } from '@assets/icons';

import {
  BreadcrumbItem,
  BreadcrumbItemDetail,
  BreadCrumbLink,
  Container,
  Name,
  NameGift,
  NextArrow,
  Wrapper,
} from './BreadcrumbStyle';

export interface BreadcrumbProps {
  items: {
    title?: string;
    url?: string;
  }[];
  detail?: boolean;
  giftCard?: boolean;
  setIsRedirecting?: (value: boolean) => void;
}

const Breadcrumb = ({
  items,
  detail,
  giftCard,
  setIsRedirecting,
}: BreadcrumbProps) => (
  <Wrapper>
    <Container>
      {items?.map((item, index) => (
        <Fragment key={item.title}>
          {detail ? (
            <BreadcrumbItemDetail key={item?.title}>
              {items?.length - 1 !== index ? (
                <>
                  {item?.url ? (
                    <BreadCrumbLink
                      href={item?.url}
                      onClick={
                        item?.url ? () => setIsRedirecting?.(true) : undefined
                      }
                      prefetch={false}
                    >
                      <>
                        {!giftCard ? (
                          <Name>{item?.title}</Name>
                        ) : (
                          <NameGift>{item?.title}</NameGift>
                        )}
                      </>
                    </BreadCrumbLink>
                  ) : (
                    <>
                      {!giftCard ? (
                        <Name>{item?.title}</Name>
                      ) : (
                        <NameGift>{item?.title}</NameGift>
                      )}
                    </>
                  )}
                  <NextArrow icon={ChevronRight} fontSize={8} />
                </>
              ) : (
                <>
                  {!giftCard ? (
                    <Name>{item?.title}</Name>
                  ) : (
                    <NameGift>{item?.title}</NameGift>
                  )}
                </>
              )}
            </BreadcrumbItemDetail>
          ) : (
            <BreadcrumbItem key={item?.title}>
              {items.length - 1 !== index ? (
                <>
                  {item?.url ? (
                    <BreadCrumbLink
                      onClick={
                        item?.url ? () => setIsRedirecting?.(true) : undefined
                      }
                      href={item?.url}
                      prefetch={false}
                    >
                      {!giftCard ? (
                        <Name>{item?.title}</Name>
                      ) : (
                        <NameGift>{item?.title}</NameGift>
                      )}
                    </BreadCrumbLink>
                  ) : (
                    <>
                      {!giftCard ? (
                        <Name>{item?.title}</Name>
                      ) : (
                        <NameGift>{item?.title}</NameGift>
                      )}
                    </>
                  )}
                  <NextArrow icon={ChevronRight} fontSize={8} />
                </>
              ) : (
                <>
                  {!giftCard ? (
                    <Name>{item?.title}</Name>
                  ) : (
                    <NameGift>{item?.title}</NameGift>
                  )}
                </>
              )}
            </BreadcrumbItem>
          )}
        </Fragment>
      ))}
    </Container>
  </Wrapper>
);

export default Breadcrumb;
